import {
  Assignment,
  Description,
  FamilyRestroom,
  FileCopy,
  MedicalServices,
  MoreHoriz,
} from "@mui/icons-material";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { ScreenMobile } from "../../../../../components/common/ScreenMobile";
import { ViewDocs } from "./ViewDocs";
import { MoreOptions } from "./MoreOptions";
import { MyfamilyForDash } from "../../../../myfamily/MyfamilyForDash";

export default function QuickActionsMobile() {
  const [openDocs, setOpenDocs] = useState<boolean>(false);
  const [options, setOptions] = useState<boolean>(false);
  const [type, setType] = useState<string>("");
  const [myFamily, setMyFamily] = useState<boolean>(false);

  const typeDict: { [key: string]: string } = {
    Notes: "Receitas médicas",
    Exames: "Solicitações de exame",
    Procedures: "Procedimentos",
    Certificates: "Relatórios e atestados",
    MyFamily: "Minha família",
  };

  const cards = [
    {
      name: "Receitas médicas",
      icon: <Assignment fontSize="large" sx={{ color: "primary800.main" }} />,
      onClick: (e: any) => {
        e.preventDefault();
        setOpenDocs(true);
        setType("Notes");
      },
    },
    {
      name: "Solicitações de exame",
      icon: <Description fontSize="large" sx={{ color: "primary800.main" }} />,
      onClick: (e: any) => {
        e.preventDefault();
        setOpenDocs(true);
        setType("Exames");
      },
    },
    {
      name: "Procedimentos",
      icon: <MedicalServices fontSize="large" sx={{ color: "primary800.main" }} />,
      onClick: (e: any) => {
        e.preventDefault();
        setOpenDocs(true);
        setType("Procedures");
      },
    },
    {
      name: "Relatórios médicos",
      icon: <FileCopy fontSize="large" sx={{ color: "primary800.main" }} />,
      onClick: (e: any) => {
        e.preventDefault();
        setOpenDocs(true);
        setType("Certificates");
      },
    },
    {
      name: "Minha família",
      icon: (
        <FamilyRestroom fontSize="large" sx={{ color: "primary800.main" }} />
      ),
      onClick: (e: any) => {
        e.preventDefault();
        setMyFamily(true);
      },
    },
    {
      name: "Mais opções",
      icon: <MoreHoriz fontSize="large" sx={{ color: "primary800.main" }} />,
      onClick: (e: any) => {
        e.preventDefault();
        setOptions(true);
      },
    },
  ];

  return (
    <Stack
      width="100%"
      maxWidth="100vw"
      justifyContent="flex-start"
      alignItems="flex-start"
      sx={{
        borderRadius: { xs: "12px", md: "30px" },
        padding: { xs: "8px", sm: "12px" },
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      <Stack
        direction="row"
        width="100%"
        overflow={{ xs: "auto", md: "visible" }}
        spacing={{ xs: "12px", sm: "16px" }}
        pb="8px"
        sx={{
          "&::-webkit-scrollbar": {
            height: "3px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "primary700.main",
            borderRadius: "3x",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "rgba(0,0,0,0.1)",
            borderRadius: "3px",
          },
        }}
      >
        {cards.map((card, index) => (
          <Card
            key={index}
            sx={{
              minWidth: "140px",
              height: "140px",
              display: "flex",
              flexDirection: "column",
              borderRadius: "4px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              transition: "all 0.2s ease",
              flexShrink: 0,
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
              },
              "&:active": {
                transform: "translateY(0px) scale(0.98)",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              },
            }}
            onClick={card.onClick}
          >
            <CardActionArea
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                padding: "12px",
                borderRadius: "4px",
                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.02)",
                },
                "&:active": {
                  backgroundColor: "rgba(0,0,0,0.04)",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "12px 0",
                  minHeight: "60px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "48px",
                    height: "48px",
                    borderRadius: "4px",
                    backgroundColor: "rgba(0,0,0,0.02)",
                    transition: "all 0.2s ease",
                  }}
                >
                  {card.icon}
                </Box>
              </Box>
              <CardContent
                sx={{
                  padding: "4px 0 0 0",
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  gutterBottom
                  component="div"
                  align="center"
                  variant="subtitle2"
                  fontWeight={500}
                  sx={{
                    fontSize: "12px",
                    lineHeight: 1.2,
                    color: "neutral900.main",
                    wordBreak: "break-word",
                  }}
                >
                  {card.name}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Stack>

      {/* Modal para visualização de documentos */}
      {openDocs && (
        <ScreenMobile
          open={openDocs}
          onClose={() => {
            setOpenDocs(false);
            setType("");
          }}
          title={typeDict[type]}
        >
          <ViewDocs type={type || "Notes"} />
        </ScreenMobile>
      )}

      {/* Modal para minha família */}
      {myFamily && (
        <ScreenMobile
          open={myFamily}
          onClose={() => {
            setMyFamily(false);
          }}
          title="Minha família"
        >
          <MyfamilyForDash />
        </ScreenMobile>
      )}

      {/* Modal para mais opções */}
      {options && (
        <ScreenMobile
          open={options}
          onClose={() => setOptions(false)}
          title="Mais opções"
        >
          <MoreOptions />
        </ScreenMobile>
      )}
    </Stack>
  );
}
